// data.service.ts
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class DriverService {
      private balanceSubject = new BehaviorSubject<number>(0);
      balance$ = this.balanceSubject.asObservable();
      sharedData: any; // This variable will store the shared data
      driverTypeList: any[] = [];
      transportList: any[] = [];
      driverAccountTypeList: any[] = [];
      driverStatusTypeList: any[] = [];
      driverTypesList: any[] = [];
      assignLocationList: any[] = [];
      listOfDrivers: any[];
      driverFullDetailsObj: any;
      Weightage: any = [];
      Customer: any = []
      Employee: any = []
      Module: any = [];
      ReasonData: any = [];
      totalReasonCount: number = 0;
      constructor(private _appService: appService, private translate: TranslateService,
            private toastr: ToastrService, private datePipe: DatePipe, private modalService: NgbModal) { }

      getDriverType(): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "DriverType")
                        .subscribe(
                              (response) => {
                                    
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.driverTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    var driverTypeerror = this.translate.instant("NewDriver.ErrorfetchingDrivertyp")
                                    this.toastr.error(
                                          driverTypeerror,
                                          "error"
                                    );
                              }
                        );
            });
      }

      getTransportList(): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .Get("VehicleMaster", "GetTranportList")
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Name;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.transportList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    var driverTypeerror = this.translate.instant("NewDriver.ErrorfetchingTransporttyp")
                                    this.toastr.error(
                                          driverTypeerror,
                                          "error"
                                    );
                              }
                        );
            })
      }

      getLicenceTypeList(): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "DriverLicenseType").subscribe(
                              (response) => {
                                    
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.transportList = response;
                                    resolve(this.transportList);
                              },
                              (err) => {
                                    var driverTypeerror = this.translate.instant("NewDriver.ErrorfetchingLicensetyp")
                                    this.toastr.error(
                                          driverTypeerror,
                                          "error"
                                    );
                              }
                        );
            })
      }

      getAssignLocationList(TenantId, userId): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetById("Company", "GetUserCompany",TenantId).subscribe(
                              (response) => {
                                    
                                    if (response.data) {
                                          response.data.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.transportList = response.data;
                                    resolve(response.data);

                              },
                              (err) => {
                                    var driverTypeerror = this.translate.instant("NewDriver.ErrorfetchingDrivertyp")
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                              }
                        );
            })
      }

      getDriverStatusType(): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "DriverStatusType")
                        .subscribe(
                              (response) => {
                                    
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.driverStatusTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                              }
                        );
            })
      }

      getAccountListOfDriver(): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetByQueryPage("ChartsofAccount", "GetAccountListforDriver", "%%", 1)
                        .subscribe(
                              (response) => {
                                    
                                    if (response.Results) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    this.driverAccountTypeList = response.Results;
                                    resolve(this.driverAccountTypeList);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                              }
                        );
            })
      }

      getAdressDetailByPostcode(param): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetByOneParam("Company", "getPostalCode", param)
                        .subscribe(
                              (response) => {
                                    
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                              }
                        );
            })
      }

      getCountryDetailByPostcode(param, category, parentId): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetByQueryPageCategoryNameParentId("Company", "GetCountryWiseList", param, 1, category, parentId)
                        .subscribe(
                              (response) => {
                                    
                                    if (response && response.Results) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response.Results);
                                    return response.Results;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching data!",
                                          "error"
                                    );
                              }
                        );
            })
      }

      showDriverPassword(driverCode): Promise<any> {
            Helpers.setLoading(true);
            return new Promise((resolve) => {
                  this._appService
                        .GetById(
                              "DriverMaster",
                              "dd_ShowPasswordDriver",
                              driverCode
                        )
                        .subscribe((response) => {
                              resolve(response);
                              Helpers.setLoading(false);
                        });
            })

      }

      resetDriverPassword(driverCode): Promise<any> {
            Helpers.setLoading(true);
            return new Promise((resolve) => {
                  this._appService
                        .GetById(
                              "DriverMaster",
                              "SendResetPasswordDriver",
                              driverCode
                        )
                        .subscribe((response) => {
                              if (response === 0) {
                                    const msg = 'Password Reset Successfully'
                                    this.toastr.success(msg, 'Success');
                              }
                              resolve(response);
                              Helpers.setLoading(false);
                        });
            })

      }

      DeleteContactById(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: this.translate.instant("BOOKINGSCOMPLETED.revert"),
                        title: this.translate.instant("BOOKINGSCOMPLETED.AreYouSure"),
                        confirmButtonText: this.translate.instant("BOOKINGSCOMPLETED.Yesdeleteit"),
                  };
                  dialogRef.componentInstance.close.subscribe((res: boolean) => {
                        if (res) {
                              this._appService.Delete("DriverMaster", "DeleteContact", Id).subscribe(
                              (response) => {
                                    this.toastr.success(this.translate.instant("Detail Deleted Successfully !"), 'Success');
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(this.translate.instant("An error occurred while deleting data!"), 'Error');
                              });
                        }
                        dialogRef.close();
                  });
            })
      }

      deleteBankAccountById(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: this.translate.instant("BOOKINGSCOMPLETED.revert"),
                        title: this.translate.instant("BOOKINGSCOMPLETED.AreYouSure"),
                        confirmButtonText: this.translate.instant("BOOKINGSCOMPLETED.Yesdeleteit"),
                  };
                  dialogRef.componentInstance.close.subscribe((res: boolean) => {
                        if (res) {
                              this._appService.Delete("DriverMaster", "DeleteBankDetail", Id).subscribe(
                              (response) => {
                                    var detailsdeleted = this.translate.instant("BOOKINGSCOMPLETED.Bankdetaildeleted")
                                    this.toastr.success(detailsdeleted, 'Success');
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(this.translate.instant("An error occurred while deleting data!"), 'Error');
                              });
                        }
                        dialogRef.close();
                  });
            })
      }

      deleteDriverDetailsById(Id): Promise<any> {

            return new Promise((resolve) => {
                  var that = this;
                  const AreYouSure = this.translate.instant("BOOKINGSCOMPLETED.AreYouSure");
                  const revert = this.translate.instant("BOOKINGSCOMPLETED.revert");
                  const Yesdeleteit = this.translate.instant("BOOKINGSCOMPLETED.Yesdeleteit");

                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: AreYouSure,
                        title: 'Warning',
                  };

                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              that._appService.Delete("DriverMaster", "DeleteDriver", Id).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);
                                    if (resJSON._body === '101') {
                                          const cannotDelete = that.translate.instant('BOOKINGSCOMPLETED.cannotdelete');
                                          that.toastr.warning(cannotDelete, 'Warning');
                                    } else if (resJSON._body === '100') {
                                          const cannotDeleteDriv = that.translate.instant('BOOKINGSCOMPLETED.cannotdeletedriv');
                                          that.toastr.warning(cannotDeleteDriv, 'Warning');
                                    } else {
                                          const deleteSuccess = that.translate.instant('BOOKINGSCOMPLETED.deleteSucess');
                                          that.toastr.success(deleteSuccess, 'Success');
                                          resolve(1);
                                    }
                                    Helpers.setLoading(false);
                              }, err => {
                                    var deleteerror = this.translate.instant("BOOKINGSCOMPLETED.DeleteErrorDriver")
                                    Helpers.setLoading(false);
                                    that.toastr.success(deleteerror, 'Error');
                              });
                        }
                        dialogRef.close();
                  });
            });
      }


      calculateDaysBetweenDates(date1: any, date2: any): string {
            if (date1 && date2) {
                  date1 = new Date(date1);
                  date2 = new Date(date2);
                  const timeDifference = Math.abs(date2.getTime() - date1.getTime());
                  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                  if (date2 >= date1) {
                        // The date is yet to expired
                        return (daysDifference + 1 + ' ' + 'Days');
                  } else {
                        return (daysDifference + ' ' + 'Days' + ' ' + 'Expired');

                  }

            }
      }

      formatSelectedDate(date): string {
            if (!!date) {
                  const newDate = new Date(date);
                  return this.datePipe.transform(newDate, 'dd-MM-yy');
            }
      }
      //added by rahul
      GetWeightage() {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "ReasonWeightage")
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map((x) => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          });
                                    }

                                    this.Weightage = response;

                                    // Logging the IDs
                                    if (this.Weightage) {
                                          this.Weightage.forEach((item) => {
                                                console.log(item.Id); // Assuming the ID field is named 'Id'
                                          });
                                    }

                                    resolve(this.Weightage);
                              },
                              (err) => {
                                    var Weightageerror = this.translate.instant("BOOKINGSCOMPLETED.Reasonfetcherror")
                                    this.toastr.error(
                                          Weightageerror,
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            });
      }

      ReasonForId: any
      GetReasonFor() {
            return new Promise((resolve) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "Reason")
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;

                                          })
                                    }
                                    this.ReasonForId = response;
                                    resolve(this.Weightage);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Reason Data !",
                                          "error"
                                    );
                              }

                        );
            })
      }
      getCutomerlist() {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("OrdersByVehicle", "GetcustomerListNEw")
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map((x) => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          });
                                    }

                                    this.Customer = response;

                                    // Logging the IDs
                                    if (this.Customer) {
                                          this.Customer.forEach((item) => {
                                                // console.log(item.Id);
                                          });
                                    }

                                    resolve(this.Customer);
                              },
                              (err) => {
                                    var Weightageerror = this.translate.instant("BOOKINGSCOMPLETED.Reasonfetcherror")
                                    this.toastr.error(
                                          Weightageerror,
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            });
      }

      deleteReason(Id): Promise<any> {

            return new Promise((resolve) => {
                  var that = this;
                  const AreYouSure = this.translate.instant("BOOKINGSCOMPLETED.AreYouSure");
                  const revert = this.translate.instant("BOOKINGSCOMPLETED.revert");
                  const Yesdeleteit = this.translate.instant("BOOKINGSCOMPLETED.Yesdeleteit");
                  swal({
                        title: AreYouSure,
                        text: revert,
                        type: "warning",
                        showCancelButton: !0,
                        confirmButtonText: Yesdeleteit
                  }).then(function (e) {
                        if (e.value == true) {
                              Helpers.setLoading(true);
                              that._appService.Delete("ReasonMaster", "DeleteReason", Id).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);
                                    if ((resJSON._body == 2)) {
                                          that.toastr.warning(
                                                "Can't delete"
                                          );
                                    } else if ((resJSON._body == 3)) {
                                          that.toastr.warning(
                                                "Can'tdelete becuase transactions are exists in Reminders "
                                          );
                                    } else {
                                          that.toastr.success(
                                                "Reason Deleted Successfully !",
                                                "Success"
                                          );
                                          resolve(1);
                                    }
                                    Helpers.setLoading(false);
                              }, err => {
                                    Helpers.setLoading(false);
                                    that.toastr.error("An error occured while deleting data !", 'error');
                              });
                        }
                  })
            })
      }
      start: number = 0;
      Length: number = 20;
      searchValue: string = '';
      filterObj: any = {
            Label: ''
      };
      GetReason(start: number = this.start, Length: number = this.Length, filterObject: any = this.filterObj, searchValue = this.searchValue) {

            Helpers.setLoading(true);
            this._appService.Post('ReasonMaster', 'GetReason', {
                  start,
                  Length,
                  searchValue,
                  ReasonForName: filterObject.ReasonForName,
                  WeightageName: filterObject.WeightageName,
            }).subscribe(
                  (response) => {
                        if (response) {
                              this.totalReasonCount = response.length;
                              console.log('Total number of records:', this.totalReasonCount);
                        }
                        
                        //this.tableDetails.data = response;
                        Helpers.setLoading(false);
                  },
                  (err) => {
                        var Reasonfetcherror = this.translate.instant("BOOKINGSCOMPLETED.Reasonfetcherror")
                        this.toastr.error(
                              Reasonfetcherror,
                              "error"
                        );
                  }
            );
      }
      setBalance(balance: number) {
            this.balanceSubject.next(balance);
      }

      GetEmployeeLsit() {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("Network", "GetEmployeeLsit")
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map((x) => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          });
                                    }

                                    this.Employee = response;

                                    // Logging the IDs
                                    if (this.Employee) {
                                          this.Employee.forEach((item) => {
                                                //  console.log(item.Id);
                                          });
                                    }

                                    resolve(this.Employee);
                              },
                              (err) => {
                                    var Weightageerror = this.translate.instant("BOOKINGSCOMPLETED.Reasonfetcherror")
                                    this.toastr.error(
                                          Weightageerror,
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            });
      }

}
